export const PRO = 'PRO';
export const MONEY_MOVEMENT = {
  INPUT_CLASS_NAME: 'border rounded-md focus:outline-none w-[17.5rem] h-[4rem] text-center font-metricMedium text-2xl',
  ERROR_MESSAGE_CLASS_NAME: 'text-center font-metricMedium text-xxs text-red02 mb-[4.188rem]',
  ADD: {
    TITLE: 'EMERGENCY_BUCKET_MOVEMENT_ADD_PAGE_SUBHEADER',
    TEXT_1: 'EMERGENCY_BUCKET_MOVEMENT_ADD_PAGE_TEXT_1',
    TEXT_2: 'EMERGENCY_BUCKET_MOVEMENT_ADD_PAGE_TEXT_2',
    BUTTON: 'EMERGENCY_BUCKET_MOVEMENT_ADD_PAGE_BUTTON_TEXT',
    ERROR_MESSAGE: 'EMERGENCY_BUCKET_MOVEMENT_ADD_PAGE_ERROR_MESSAGE',
  },
  WITHDRAW: {
    TITLE: 'EMERGENCY_BUCKET_MOVEMENT_WITHDRAW_PAGE_SUBHEADER',
    TEXT: {
      BASIC_1: 'EMERGENCY_BUCKET_MOVEMENT_WITHDRAW_PAGE_TEXT_BASIC_1',
      BASIC_2: 'EMERGENCY_BUCKET_MOVEMENT_WITHDRAW_PAGE_TEXT_BASIC_2',
      PRO_1: 'EMERGENCY_BUCKET_MOVEMENT_WITHDRAW_PAGE_TEXT_PRO_1',
      PRO_2: 'EMERGENCY_BUCKET_MOVEMENT_WITHDRAW_PAGE_TEXT_PRO_2',
    },
    BUTTON: 'EMERGENCY_BUCKET_MOVEMENT_WITHDRAW_PAGE_BUTTON_TEXT',
    ERROR_MESSAGE_PRO: 'EMERGENCY_BUCKET_MOVEMENT_WITHDRAW_PAGE_ERROR_MESSAGE_PRO',
    ERROR_MESSAGE_BASIC: 'EMERGENCY_BUCKET_MOVEMENT_WITHDRAW_PAGE_ERROR_MESSAGE_BASIC',
  },
  PROCESSING: 'BUTTON_LOADER_TEXT',
} as const;

export const SET_UP_AUTO_SAVING = {
  MIN_DAILY_SAVING: 1,
  MAX_DAILY_SAVING: 100,
  TITLE: {
    CLASS_NAME: 'font-metricMedium text-bw08 text-lg mb-2',
    STEP_1: 'SET_UP_AUTO_SAVINGS_COMPONENT_HEADER_STEP_1',
    STEP_2: 'SET_UP_AUTO_SAVINGS_COMPONENT_HEADER_STEP_2',
  },
  TEXT: {
    CLASS_NAME_STEP_1: 'font-metric text-bw07 text-sm text-center leading-[1.313rem] mb-[3rem]',
    CLASS_NAME_STEP_2: 'font-metric text-bw07 text-sm mb-[3rem] text-center leading-[1.063rem] px-5',
    STEP_1: 'SET_UP_AUTO_SAVINGS_COMPONENT_TEXT_STEP_1',
    STEP_2: 'SET_UP_AUTO_SAVINGS_COMPONENT_TEXT_STEP_2',
  },
  INPUT: {
    CLASS_NAME:
      'border rounded-md focus:outline-none w-[17.5rem] h-[4rem] text-center font-metricMedium text-2xl mb-[0.875rem]',
  },
  VALUE_TO_CONFIRM: {
    CLASS_NAME: 'text-[2.75rem] text-action03 font-metricMedium leading-[3.25rem]',
  },
  A_DAY: {
    PLACE_HOLDER: 'SET_UP_AUTO_SAVINGS_COMPONENT_A_DAY',
    CLASS_NAME_STEP_1: 'text-base font-metric leading-6 text-bw05 h-[1.563rem] flex items-center',
    CLASS_NAME_STEP_2: 'text-base font-metric leading-6 text-action03',
  },
  ERROR_MESSAGE: {
    MESSAGE: 'SET_UP_AUTO_SAVINGS_ERROR_MESSAGE',
    CLASS_NAME: 'h-[2.375rem] text-center font-metricMedium text-xxs text-red02 px-10 mb-[1.5rem]',
  },
  BUTTON: {
    CLASS_NAME: 'w-[17.5rem] h-[3.125rem] font-metricBold text-sm text-bw00 rounded-umd',
    TITLE: {
      STEP_1: 'SET_UP_AUTO_SAVINGS_COMPONENT_BUTTON_TEXT_STEP_1',
      STEP_2: 'SET_UP_AUTO_SAVINGS_COMPONENT_BUTTON_TEXT_STEP_2',
    },
  },
  DISCLAIMER: {
    CLASS_NAME: 'text-sm font-metric text-bw07 text-center',
    PLACE_HOLDER: {
      BASIC: 'SET_UP_AUTO_SAVINGS_COMPONENT_PLACE_HOLDER_BASIC',
      PRO: 'SET_UP_AUTO_SAVINGS_COMPONENT_PLACE_HOLDER_PRO',
    },
  },
  TERMS_CONDITIONS: {
    CLASS_NAME: 'text-sm font-metricMedium text-action03 underline',
    TEXT: 'SET_UP_AUTO_SAVINGS_COMPONENT_TERMS_CONDITIONS',
  },
} as const;

export const AUTO_SAVING_DATA = {
  TITLE: 'AUTO_SAVING_COMPONENT_HEADER',
  A_DAY: 'AUTO_SAVING_COMPONENT_A_DAY',
  TEXT_1: 'AUTO_SAVING_COMPONENT_TEXT_1',
  TEXT_2: 'AUTO_SAVING_COMPONENT_TEXT_2',
  BUTTON: 'AUTO_SAVING_COMPONENT_BUTTON',
} as const;

export const START_AUTO_SAVING_POPUP_TEXTS = {
  SUCCESS_BASIC: 'FIRST_SET_UP_AUTO_SAVINGS_SUCCESS_MESSAGE_BASIC',
  SUCCESS_PRO: 'FIRST_SET_UP_AUTO_SAVINGS_SUCCESS_MESSAGE_PRO',
  SUCCESS_CHANGED_1: 'CHANGED_DAILY_SAVINGS_MESSAGE_1',
  SUCCESS_CHANGED_2: 'CHANGED_DAILY_SAVINGS_MESSAGE_2',
  FAILURE_BASIC: '',
  FAILURE_PRO: '',
} as const;

export const ADD_WITHDRAW_POPUP_TEXT = {
  USER_BASIC: {
    ADD: 'EMERGENCY_BUCKET_MONEY_MOVEMENT_ADD_POPUP_TEXT_BASIC',
    WITHDRAW: 'EMERGENCY_BUCKET_MONEY_MOVEMENT_WITHDRAW_POPUP_TEXT_BASIC',
  },
  USER_PRO: {
    ADD: 'EMERGENCY_BUCKET_MONEY_MOVEMENT_ADD_POPUP_TEXT_PRO',
    WITHDRAW: 'EMERGENCY_BUCKET_MONEY_MOVEMENT_WITHDRAW_POPUP_TEXT_PRO',
  },
} as const;

export const POPUP_LIFESPAN = 5000;

export const SUB_PATHS = {
  ADD_PATH: ':false',
  WITHDRAW_PATH: ':true',
  EMERGENCY_BUCKET_ACTIVATED: ':isSavingsActivated',
};

export const PAGE_HEADERS = {
  SAVINGS: 'EMERGENCY_BUCKET_HEADER_PRO',
  EMERGENCY: 'EMERGENCY_BUCKET_HEADER_BASIC',
  WITHDRAW: {
    SAVINGS: 'EMERGENCY_BUCKET_MOVEMENT_WITHDRAW_PAGE_HEADER_PRO',
    EMERGENCY: 'EMERGENCY_BUCKET_MOVEMENT_WITHDRAW_PAGE_HEADER_BASIC',
  },
  ADD: {
    SAVINGS: 'EMERGENCY_BUCKET_MOVEMENT_ADD_PAGE_HEADER_PRO',
    EMERGENCY: 'EMERGENCY_BUCKET_MOVEMENT_ADD_PAGE_HEADER_BASIC',
  },
} as const;

export const BALANCE_HEADERS = {
  BASIC_USER: 'EMERGENCY_BUCKET_BALANCE_COMPONENT_TEXT_BASIC',
  PRO_USER: 'EMERGENCY_BUCKET_BALANCE_COMPONENT_TEXT_PRO',
} as const;

export const BUTTONS_TEXTS = {
  ADD: 'EMERGENCY_BUCKET_BALANCE_COMPONENT_BUTTON_ADD_TEXT',
  WITHDRAW: 'EMERGENCY_BUCKET_BALANCE_COMPONENT_BUTTON_WITHDRAW_TEXT',
} as const;

export const START_STEPS = {
  STEP_1: 1,
  STEP_2: 2,
};

export const MAX_AUTO_SAVING_ALLOWED_DIGITS = 3;
